<template>
  <div class="box box--person">
    <Bookmark :contentId="box.idContent"></Bookmark>
    <div class="box-img-wrapper">
      <ImageWrapper :file="box.idPicture" :key="box.idPicture" v-if="box.idPicture"></ImageWrapper>
      <img v-else src="../../assets/images/avatar-placeholder.png">
    </div>
    <span class="box-person-name">{{box.name}}</span>
    <span class="box-person-position">{{box.role}}</span>
    <span class="span-icon" v-if="box._embedded && box._embedded.Country"><i class="icon-net"></i> {{box._embedded.Country.value}}</span>
    <a v-if="box.email" class="link-icon" :href="`mailto:${box.email}`"><i class="icon-mail-1"></i> <span>{{box.email}}</span></a>
    <a class="link-regular" @click="openPopup" v-if="!hideDetails">View profile</a>

    <transition name="fade">
      <div class="popup-wrapper" v-if="showPopup ">
        <div class="popup-overlay" @click="closePopup"></div>
        <div class="popup">
          <button class="popup-close3" @click="closePopup"></button>
          <div class="popup-img-wrapper">
            <div class="popup-img">
              <ImageWrapper :file="box.idPicture" :key="`modal-${box.idPicture}`"></ImageWrapper>
            </div>
            <Bookmark :contentId="box.idContent"></Bookmark>
          </div>
          <span class="popup-person-name">{{box.name}}</span>
          <span class="popup-person-position">{{box.role}}</span>
          <span class="popup-person-place" v-if="box._embedded && box._embedded.Country">{{box._embedded.Country.value}}</span>
          <div class="buttons">
            <Tooltip v-if="box.email" :tooltip-class="'tooltip--bottom'" :key="`mail-${box.idTeamMember}`">
              <template v-slot:tooltipButtonTemplate>
                <a :href="`mailto:${box.email}`"><i class="icon-mail"></i></a>
              </template>
              <template v-slot:tooltipBubbleTemplate>
                <a :href="`mailto:${box.email}`">{{box.email}}</a>
<!--                <button><i class="icon-copy"></i></button>-->
              </template>
            </Tooltip>
            <Tooltip v-if="box.phone" :tooltip-class="'tooltip--bottom'" :key="`phone-${box.idTeamMember}`">
              <template v-slot:tooltipButtonTemplate>
                <i class="icon-phone"></i>
              </template>
              <template v-slot:tooltipBubbleTemplate>
                <span>{{box.phone}}</span>
<!--                <button><i class="icon-copy"></i></button>-->
              </template>
            </Tooltip>
            <Tooltip v-if="box.linkedIn" :tooltip-class="'tooltip--bottom'" :key="`linkedIn-${box.idTeamMember}`">
              <template v-slot:tooltipButtonTemplate>
                <a target="_blank" :href="`https://www.linkedin.com/in/${box.linkedIn}`"><i class="icon-li"></i></a>
              </template>
              <template v-slot:tooltipBubbleTemplate>
                <a target="_blank" :href="`https://www.linkedin.com/in/${box.linkedIn}`">https://www.linkedin.com/in/{{box.linkedIn}}</a>
<!--                <button><i class="icon-copy"></i></button>-->
              </template>
            </Tooltip>
          </div>
          <div class="popup-quote" v-if="box.quotation" v-html="openLinksInNewTab(box.quotation)">
          </div>
          <div class="popup-tabs" v-if="!htmlEmpty(box.specialityArea) || (box._embedded && box._embedded.teamMemberRelatedContent && box._embedded.teamMemberRelatedContent.skills.length)">
            <div class="tabs">
              <div class="tabs-inner">
                <button v-if="!htmlEmpty(box.specialityArea)" @click="tab = 1" :class="{active: tab === 1}">Speciality area</button>
                <button v-if="box._embedded && box._embedded.teamMemberRelatedContent && box._embedded.teamMemberRelatedContent.skills.length" @click="tab = 2" :class="{active: tab === 2}">Skills</button>
                <button v-if="false" @click="tab = 3" :class="{active: tab === 3}">Team/Project field</button>
              </div>
              <div class="tabs-content">
                <div v-if="tab === 1" v-html="openLinksInNewTab(box.specialityArea)"></div>

                <div class="tags-row" v-if="tab === 2">
                  <span class="tag" v-for="skill in box._embedded.teamMemberRelatedContent.skills" :key="skill">{{skill}}</span>
                </div>

                <div class="tags-row" v-if="tab == 3">
                  <span class="tag" v-for="project in box._embedded.teamMemberRelatedContent.projects" :key="project">{{project}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="popup-table" >
            <table v-if="detailsFields.length">
              <tr v-for="field in detailsFields" :key="field.name">
                <td>{{field.name}}</td>
                <td>{{field.value}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {openLinksInNewTab} from "@/helpers/openLinksInNewTab"
import Tooltip from '@/components/general/Tooltip'
import ImageWrapper from "@/components/general/ImageWrapper";
import Bookmark from "@/components/general/Bookmark";
import userApi from "@/api/user";
export default {
  name: "TeamMemberBox",
  props: ['box', 'hideDetails'],
  components: {Bookmark, ImageWrapper, Tooltip },
  data () {
    return {
      showPopup: false,
      tab: 1
    }
  },
  computed: {
    detailsFields() {
      let fields = []
      if(this.box._embedded && this.box._embedded.Content._embedded && this.box._embedded.Content._embedded.ContentFieldValue && this.box._embedded.Content._embedded.ContentFieldValue.length) {
        this.box._embedded.Content._embedded.ContentFieldValue.forEach((item) => {
          let contentField = this.$store.getters.getContentFieldById(item.idContentField);
          let contentFieldOption = this.$store.getters.getContentFieldOptionById(item.idContentFieldOption);
          if(contentField && contentFieldOption)
          fields.push({
              name: contentField.name ,
              value: contentFieldOption.value
          })
        })
      }
      return fields
    }
  },
  methods: {
    openLinksInNewTab: openLinksInNewTab,
    openPopup () {
      userApi.logUserAccessContent({
        "idContent": this.box.idContent,
        "idUser": this.$store.getters.user.idUser,
        "idUserAccessContent":""
      })
      this.showPopup = 1
      document.querySelector('body').classList.add('nooverflow')
    },
    closePopup () {
      this.showPopup = 0
      document.querySelector('body').classList.remove('nooverflow')
    },
    htmlEmpty(html) {
      let tmp = document.implementation.createHTMLDocument("New").body;
      tmp.innerHTML = html;
      return !tmp.textContent || tmp.textContent.trim() === ''
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
